import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();

  const handleResumeDownload = () => {
    // Import and use the resume download function
    import('../utils/resumeDownload').then(module => {
      module.downloadResume();
    });
  };

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-left">
            <h2 className="footer-heading">Let's Work Together</h2>
            <div className="contact-info">
              <div className="contact-item">
                <svg className="contact-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>Queens, NY</span>
              </div>
              <div className="contact-item">
                <svg className="contact-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span>subeksha.thapa@outlook.com</span>
              </div>
              <div className="contact-item">
                <svg className="contact-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span>+1 (929)-666-1298</span>
              </div>
            </div>
            <nav className="footer-navigation">
              <a href="/about">About</a>
              <a href="/#works">Works</a>
              <a href="/#resume" onClick={handleResumeDownload}>Resume</a>
              <a href="#" onClick={(e) => { 
                e.preventDefault(); 
                navigate('/contact'); 
                window.scrollTo(0, 0); 
              }}>Contact</a>
            </nav>
          </div>
          <div className="footer-right">
            <button className="contact-me-btn" onClick={() => {
              navigate('/contact');
              window.scrollTo(0, 0);
            }}>
              <span>Contact Me!</span>
              <svg className="contact-arrow" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
